import { Flex, Spacing, Text, Textarea } from '@billy/design-system'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { INVOICE_FOOTER_CHARACTER_LIMIT } from '@features/invoices/constants/invoiceFooterCharacterLimit'

import { useFormContext } from '../../../../../../hooks'
import type { InvoicingSettingsSection } from '../../../../enums/invoicingSettingsSection'
import { useTrackInvoicingSettingsDebounced } from '../../../../hooks/useTrackInvoicingSettingsDebounced'
import type { DocumentTypeSettingsFormSchema } from '../../types/documentTypeSettingsFormSchema'
import { DocumentTypeSettingsCharacterCount } from '../DocumentTypeSettingsCharacterCount'

interface DocumentTypeSettingsFooterNoteProps {
  trackingSection: InvoicingSettingsSection
}

export const DocumentTypeSettingsFooterNote = ({
  trackingSection,
}: DocumentTypeSettingsFooterNoteProps): ReactElement => {
  const { t } = useTranslation()
  const { FormItem, watch } = useFormContext<DocumentTypeSettingsFormSchema>()

  const footerNote = watch('footerNote')

  const handleDebouncedFooterNoteChange = useTrackInvoicingSettingsDebounced('Footer note typed', {
    section: trackingSection,
  })

  return (
    <Flex flexDirection="column" gap={Spacing.S4}>
      <FormItem
        name="footerNote"
        label={
          <Text weight="medium">{t('settings.organization.external_invoice.content.default_footer_note.label')}</Text>
        }
        render={({ field: { onChange, ...rest } }) => (
          <Textarea
            {...rest}
            maxLength={INVOICE_FOOTER_CHARACTER_LIMIT}
            onChange={(event) => {
              onChange(event)
              handleDebouncedFooterNoteChange()
            }}
            placeholder={t('settings.organization.external_invoice.content.default_footer_note.placeholder')}
            rows={2}
          />
        )}
      />
      <DocumentTypeSettingsCharacterCount length={footerNote.length} limit={INVOICE_FOOTER_CHARACTER_LIMIT} />
    </Flex>
  )
}
